import {Service} from "../../service-management/service/service.model";

export interface MyRequestedServices {
  formResponse?: FormResponse
  uploadableForm?: UploadableForm
}

export interface FormResponse {
  id?:string
  uniqueId?:string
  responsePayload?: string
  submitted?:boolean
  submittedAt?:string
  status?: FormResponseStatusEnum
  service?: Service
  comments?:{
    id?: string
    uniqueId?: string
    comment?: string
    createdAt?: string
  }[]
  requestDate?: string
  expectedToDeliver?: string
}

export enum FormResponseStatusEnum {
  PENDING= "PENDING",
  COMPLETE = "COMPLETE"
}

export interface UploadableForm {
  id?: string
  uniqueId?: string
  status?: FormResponseStatusEnum
  requestDate?: string
  expectedToDeliver?: string
  attachments?: {
    path?: string
    title?: string
    isMandatory?: boolean
  }

}
